/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/display-name */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  View,
  StyleSheet,
  Dimensions,
  ActivityIndicator,
  TouchableOpacity,
} from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import {
  calculateLocationDistance,
  getActivityTodoStorage,
  setActivityTodoStorage,
  clearActivityTodoStorage,
  clearVisibilityCacheByActivity,
  uploadS3,
} from '@global/helpers';
import { isWeb, isAndroid, fullWidth } from '@global/screens';
import { VERSION, ARROW_SIZE, CHECK_SIZE } from '@/constants';
import Image from '@components/global/Image';
import Colors from '@global/colors';
import { Loader } from '@components/screen/Layout';
import Button from '@components/form/Button';
import ModalFull from '@components/modal/ModalFull';
import ModalHalf from '@components/modal/ModalHalf';
import Input from '@components/form/Input';
import SelectBox from '@components/form/SelectBox';
import SociollaText from '@components/sociolla/SociollaText';
import Alert from '@components/global/Alert';
import TabExpand from '@/screens/sales-activity/components/todo-list/on-going/TabExpand';
import TodoTitle from '@/screens/sales-activity/components/todo-list/on-going/TodoTitle';
import TodoCustomerDisplay from '@/screens/sales-activity/components/todo-list/on-going/TodoCustomerDisplay';
import TodoUploadSharePhoto from '@/screens/sales-activity/components/todo-list/on-going/TodoUploadSharePhoto';
import TodoNotes from '@/screens/sales-activity/components/todo-list/on-going/TodoNotes';
import TodoInvoice from '@/screens/sales-activity/components/todo-list/on-going/TodoInvoice';
import TodoVisibilityUpdate from '@/screens/sales-activity/components/todo-list/on-going/todo-visibility-update/TodoVisibilityUpdate';
import { resolvePromoStatus } from '@/screens/sales-activity/components/todo-list/on-going/todo-visibility-update/TodoVisibilityUpdate.utils';
import TodoCompetitorUpdate from '@/screens/sales-activity/components/todo-list/on-going/TodoCompetitorUpdate';
import TodoOrder from '@/screens/sales-activity/components/todo-list/on-going/TodoOrder';
import TodoGwpTracker from '@/screens/sales-activity/components/todo-list/on-going/TodoGwpTracker';
import TodoSellOutReport from '@/screens/sales-activity/components/todo-list/on-going/TodoSellOutReport';

import useLocation from '@/hooks/useLocation';
import { logEvent, logEventScreen } from '@global/analytics';
import {
  SALES_ACTIVITY_CATEGORY_SELECTED,
  SALES_ACTIVITY_EVENT_TYPE_SELECTED,
  SALES_ACTIVITY_PROMOTOR_CHECKOUT,
} from '@/constants/analyticsEvents';

const checkInOutSize = 120;
const dimension = Dimensions.get('screen');

const defaultTabs = [
  {
    label: 'Customer Display',
    screen: 'ActivityCustomerDisplayScreen',
    value: 'customer_display',
  },
  {
    label: 'Competitor Update',
    screen: 'ActivityCompetitorUpdateScreen',
    value: 'competitor_update',
  },
  {
    label: 'Visibility Update',
    screen: 'ActivityVisibilityUpdateScreen',
    value: 'visibility_update',
  },
  { label: 'Order', screen: 'ActivityOrderScreen', value: 'orders' },
  {
    label: 'Collect Invoice / Payment',
    screen: 'ActivityInvoiceCollectionScreen',
    value: 'invoice_collection',
  },
  {
    label: 'Visit Report',
    screen: 'ActivityNpdPresentationScreen',
    value: 'npd_presentation',
  },
  {
    label: 'Upload Store Photo',
    screen: 'ActivityUploadStorePhotoScreen',
    value: 'upload_store_photo',
  },
  {
    label: 'GWP Tracker',
    screen: 'GwpTrackerScreen',
    value: 'gwp_tracker',
  },
  {
    label: 'Sell-Out Validation Report',
    screen: 'SellOutReportScreen',
    value: 'sell_out_report',
  },
];

import { MsB2b } from '@api/ms-b2b';
import { showPopup } from '@/store/modal';
import { showAlert } from '@/store/global';

const TodoListUser = ({
  route = null,
  navigation = null,
  detailData = {},
  detailTodos = [],
  detailCustomer = {},
  hasNoInvoice = false,
  onSubmit,
  onCloseDetail = () => {},
  customerAddress = {},
}) => {
  const dispatch = useDispatch();
  const insets = useSafeAreaInsets();
  const currentLocation = useLocation();
  const containerHeight =
    dimension.height - insets.top - insets.bottom - 30 - (isAndroid ? 95 : 0);
  const isLoadingGlobal = useSelector((state) => state.modal.isLoading);
  const userData = useSelector((state) => state.auth.user);
  const [isLoadingLocation, setIsLoadingLocation] = useState(false);
  const [activeTab, setActiveTab] = useState('');
  const [tabs, setTabs] = useState([]);
  const [distance, setDistance] = useState(0);
  const [distanceInM, setDistanceInM] = useState(0);
  const [isCheckedIn, setIsCheckedIn] = useState(false);
  const [isCheckedOut, setIsCheckedOut] = useState(false);
  const [hasLocation, setHasLocation] = useState(false);
  const [showCatalog, setShowCatalog] = useState(false);
  const [showOrderForm, setShowOrderForm] = useState(false);
  const [showOrderDetail, setShowOrderDetail] = useState(false);
  const [orderDetail, setOrderDetail] = useState({});
  const [showUpdateLocation, setShowUpdateLocation] = useState(false);
  const [latLong, setLatLong] = useState({});
  const [offlineTodo, setOfflineTodo] = useState({
    items: {},
    submitStatus: {},
  });
  const offlineRef = useRef({ items: {}, submitStatus: {} });
  const [showSubmitModal, setShowSubmitModal] = useState(false);
  const [isSubmittingTodos, setIsSubmittingTodos] = useState(false);
  const [modalCheckInValidation, setModalCheckInValidation] = useState(false);
  const [checkInNotes, setCheckInNotes] = useState('');
  const [categoryActivity, setCategoryActivity] = useState(
    detailData?.category_activity || '',
  );
  const [eventActivityType, setEventActivityType] = useState(
    detailData?.event_activity_type || '',
  );
  const [eventActivityOther, setEventActivityOther] = useState(
    detailData?.event_activity_other || '',
  );
  const [isSavingCategoryActivity, setIsSavingCategoryActivity] =
    useState(false);
  const [isCategoryFormOpen, setIsCategoryFormOpen] = useState(
    () => !(detailData?.category_activity && detailData?.event_activity_type),
  );

  const activityType = detailData.activity_type || 'visiting_existing_customer';
  const customerDetail = detailData?.customer;
  const outletDetail = detailData?.outlet;
  const customerLatLong =
    customerDetail?.address?.lat_long?.latitude &&
    customerDetail?.address?.lat_long?.longitude
      ? detailData.customer.address.lat_long
      : {};
  const outletLatLong =
    outletDetail?.address?.lat_long?.latitude &&
    outletDetail?.address?.lat_long?.longitude
      ? detailData.outlet.address.lat_long
      : {};
  const activityId = detailData?._id;

  const updateOfflineState = useCallback(
    async (updater) => {
      const base = offlineRef.current || { items: {}, submitStatus: {} };
      const next = updater(base);
      offlineRef.current = next;
      setOfflineTodo(next);
      if (activityId) {
        await setActivityTodoStorage(activityId, next);
      }
    },
    [activityId],
  );

  const loadOfflineState = async () => {
    if (!activityId) {
      const empty = { items: {}, submitStatus: {} };
      offlineRef.current = empty;
      setOfflineTodo(empty);
      return;
    }
    const stored = await getActivityTodoStorage(activityId);
    const next = stored || { items: {}, submitStatus: {} };
    offlineRef.current = next;
    setOfflineTodo(next);
  };

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      if (!mounted) {
        return;
      }
      await loadOfflineState();
    };
    load();
    return () => {
      mounted = false;
    };
  }, [activityId]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (activityType == 'visiting_existing_customer') {
        if (['beauty_advisor'].includes(userData?.role?.code)) {
          setTabs([
            defaultTabs[0],
            defaultTabs[1],
            defaultTabs[2],
            defaultTabs[5],
            defaultTabs[7],
            defaultTabs[8],
          ]);
        } else if (['merchandiser'].includes(userData?.role?.code)) {
          setTabs([
            defaultTabs[0],
            defaultTabs[1],
            defaultTabs[2],
            defaultTabs[5],
          ]);
        } else {
          setTabs([
            defaultTabs[0],
            defaultTabs[1],
            defaultTabs[2],
            defaultTabs[3],
            defaultTabs[4],
            defaultTabs[5],
          ]);
        }
      } else if (activityType == 'invoice_collection') {
        setTabs([defaultTabs[4]]);
      } else if (activityType == 'engage_potential_customers') {
        setTabs([defaultTabs[5], defaultTabs[6]]);
      } else if (activityType == 'event_activity') {
        const isPromotor = userData?.role?.code === 'promotor';
        setTabs([
          defaultTabs[0], // customer_display
          defaultTabs[1], // competitor_update
          defaultTabs[2], // visibility_update
          defaultTabs[7], // gwp_tracker
          ...(isPromotor
            ? [
                defaultTabs[5], // Visit Report (npd_presentation) for promotor
                defaultTabs[8], // B2B-5929: Sell-Out Validation Report
              ]
            : [
                {
                  label: 'Visit Report',
                  screen: 'SellOutReportScreen',
                  value: 'sell_out_report',
                },
              ]),
        ]);
      }
      setIsCheckedIn(detailData.is_check_in);
      setIsCheckedOut(detailData.is_check_out);
      if (
        detailData?._id &&
        route?.params?.direct &&
        activeTab != route?.params?.direct
      ) {
        setTimeout(() => {
          setActiveTab(route.params.direct);
        }, 500);
      }
    }
    return () => {
      mounted = false;
    };
  }, [detailData]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (showCatalog && !activeTab) {
        setShowCatalog(false);
        onCloseDetail();
        navigation.navigate('CatalogNavigator', {
          screen: 'CatalogScreen',
          params: {
            activitiyId: detailData?._id,
          },
        });
      }
    }
    return () => {
      mounted = false;
    };
  }, [showCatalog, activeTab]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (showOrderForm) {
        let delivery_customer = detailData?.customer || {};
        if (detailData?.customer?.address?.id) {
          delivery_customer = {
            ...detailData?.customer,
            address: {
              ...detailData?.customer?.address,
              _id: detailData?.customer?.address?.id,
            },
          };
        }
        setShowOrderForm(false);
        navigation.navigate('SalesOrderNavigator', {
          screen: 'SalesOrderFormScreen',
          params: {
            activityId: detailData?._id,
            taskId: dataOrder?._id,
            customerActivityId: detailData?.customer?.id,
            id: '',
            name: '',
            titleScreen: '',
            deliveryAddress: delivery_customer,
          },
        });
      }
    }
    return () => {
      mounted = false;
    };
  }, [showOrderForm]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (showOrderDetail && Object.keys(orderDetail).length && !activeTab) {
        setShowOrderDetail(false);
        const order = JSON.parse(JSON.stringify(orderDetail));
        setOrderDetail({});
        onCloseDetail();
        navigation.navigate('SalesOrderNavigator', {
          screen: 'SalesOrderDetailScreen',
          params: {
            activityId: order?.activity_id,
            taskId: order?.task_id,
            id: order._id,
            name: order.reference_code,
            titleScreen: order.reference_code,
          },
        });
      }
    }
    return () => {
      mounted = false;
    };
  }, [orderDetail, showOrderDetail, activeTab]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (route?.params?.direct && activeTab == route.params.direct) {
        setTimeout(() => {
          navigation.setParams({ direct: '' });
        }, 500);
      }
      if (defaultTabs.findIndex((a) => a.value == activeTab) > -1) {
        const tab = defaultTabs.find((a) => a.value == activeTab);
        logEventScreen(tab.screen);
      } else if (!activeTab) {
        logEventScreen('TodoList');
      }
    }
    return () => {
      mounted = false;
    };
  }, [activeTab]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      getDistanceLocation();
    }
    return () => {
      mounted = false;
    };
  }, [currentLocation]);

  const getDistanceLocation = async () => {
    setShowUpdateLocation(false);
    setIsLoadingLocation(false);
    setLatLong({});

    try {
      if (!currentLocation?.loading) {
        if (currentLocation?.latitude && currentLocation?.longitude) {
          console.log('Permission granted!');
          setLatLong({
            latitude: currentLocation.latitude,
            longitude: currentLocation.longitude,
          });
          setHasLocation(true);
        } else {
          console.log('Permission not granted!');
          setHasLocation(false);
        }
      }
    } catch (err) {
      console.log('err', err);
    }
  };

  // Customer Display
  const dataCustomerDisplay = detailTodos.find(
    (a) => a.target_type == 'customer_display',
  );

  // NPD Presentation (Visit Report)
  const dataNpsPresentation = detailTodos.find(
    (a) => a.target_type == 'npd_presentation',
  );

  // Invoice Collection
  const dataInvoiceCollection = detailTodos.find(
    (a) => a.target_type == 'invoice_collection',
  );

  // Visibility Update
  const dataVisibilityUpdate = detailTodos.find(
    (a) => a.target_type == 'visibility_update',
  );

  // Share Photo
  const dataSharePhoto = detailTodos.find(
    (a) => a.target_type == 'upload_store_photo',
  );

  // Competitor Update
  const dataCompetitorUpdate = detailTodos.find(
    (a) => a.target_type == 'competitor_update',
  );

  // Order
  const dataOrder = detailTodos.find((a) => a.target_type == 'orders');

  // GWP Tracker
  const dataGwpTracker = detailTodos.find(
    (a) => a.target_type == 'gwp_tracker',
  );

  // Sell-out Validation Report
  const dataSellOutReport = detailTodos.find(
    (a) => a.target_type == 'sell_out_report',
  );

  // B2B-5929: promotor Sell-Out Validation Report is optional and only exists on
  // activities created after it was added, so hide the tab instead of blocking submit
  const visibleTabs = tabs.filter(
    (item) =>
      item.value !== 'sell_out_report' ||
      activityType !== 'event_activity' ||
      userData?.role?.code !== 'promotor' ||
      Boolean(dataSellOutReport),
  );

  // check the activity todo list is exists
  // Visit customer should have todo list customer display, npd presentation, invoice collection and visibility update
  // Invoice collection should have todo list invoice collection
  // Engage customer should have todo list npd presentation and upload store photo
  let hasNoTodoList = [];
  if (!dataCustomerDisplay && activityType == 'visiting_existing_customer') {
    // check customer display exists
    hasNoTodoList.push('customer_display');
  }
  if (
    !dataNpsPresentation &&
    ['visiting_existing_customer', 'engage_potential_customers'].includes(
      activityType,
    )
  ) {
    // check npd presentation exists
    hasNoTodoList.push('npd_presentation');
  }
  if (
    !dataInvoiceCollection &&
    ['visiting_existing_customer'].includes(activityType) &&
    !['beauty_advisor', 'merchandiser'].includes(userData?.role?.code)
  ) {
    // check invoice collection exists
    hasNoTodoList.push('invoice_collection');
  }
  if (
    !dataInvoiceCollection &&
    ['invoice_collection'].includes(activityType) &&
    !['beauty_advisor'].includes(userData?.role?.code)
  ) {
    // check invoice collection exists
    hasNoTodoList.push('invoice_collection');
  }
  if (!dataVisibilityUpdate && activityType == 'visiting_existing_customer') {
    // check visibility update exists
    hasNoTodoList.push('visibility_update');
  }
  if (
    !dataOrder &&
    activityType == 'visiting_existing_customer' &&
    !['beauty_advisor', 'merchandiser'].includes(userData?.role?.code)
  ) {
    // check order exists
    hasNoTodoList.push('orders');
  }
  if (!dataSharePhoto && activityType == 'engage_potential_customers') {
    // check engage potential customer exists
    hasNoTodoList.push('upload_store_photo');
  }
  if (!dataCompetitorUpdate && activityType == 'visiting_existing_customer') {
    // check competitor update exists
    hasNoTodoList.push('competitor_update');
  }
  if (
    !dataGwpTracker &&
    activityType == 'visiting_existing_customer' &&
    userData?.role?.code == 'beauty_advisor'
  ) {
    hasNoTodoList.push('gwp_tracker');
  }
  if (
    !dataSellOutReport &&
    activityType == 'visiting_existing_customer' &&
    userData?.role?.code == 'beauty_advisor'
  ) {
    hasNoTodoList.push('sell_out_report');
  }
  if (!dataCustomerDisplay && activityType == 'event_activity') {
    hasNoTodoList.push('customer_display');
  }
  if (!dataCompetitorUpdate && activityType == 'event_activity') {
    hasNoTodoList.push('competitor_update');
  }
  if (!dataVisibilityUpdate && activityType == 'event_activity') {
    hasNoTodoList.push('visibility_update');
  }
  if (!dataGwpTracker && activityType == 'event_activity') {
    hasNoTodoList.push('gwp_tracker');
  }
  if (activityType == 'event_activity') {
    if (userData?.role?.code === 'promotor') {
      if (!dataNpsPresentation) {
        hasNoTodoList.push('npd_presentation');
      }
    } else if (!dataSellOutReport) {
      hasNoTodoList.push('sell_out_report');
    }
  }
  if (hasNoTodoList?.length) {
    hasNoTodoList = hasNoTodoList.map((todo) => {
      const todoTab = defaultTabs.find((item) => item.value == todo);
      return todoTab ? todoTab : { label: todo, value: todo };
    });
  }

  const localItems = offlineTodo?.items || {};
  const localSubmitStatus = offlineTodo?.submitStatus || {};

  const getLocalPayload = (targetType) =>
    localItems?.[targetType]?.payload || null;

  const getLocalCompleted = (targetType) =>
    Boolean(localItems?.[targetType]?.completed);

  const attachmentHasImage = (attachments, type) =>
    Boolean(attachments?.find((a) => a?.type === type && a?.image?.length));

  const getCustomerDisplayAttachments = () =>
    getLocalPayload('customer_display')?.more_info?.attachments ??
    dataCustomerDisplay?.more_info?.attachments;

  const isCustomerDisplayReadyForCheckout = () => {
    const attachments = getCustomerDisplayAttachments();
    if (['merchandiser', 'promotor'].includes(userData?.role?.code)) {
      return attachmentHasImage(attachments, 'customer_before_visit');
    }
    return (
      attachmentHasImage(attachments, 'customer_before_visit') &&
      attachmentHasImage(attachments, 'customer_after_visit')
    );
  };

  const getBackendCompleted = (targetType) => {
    switch (targetType) {
      case 'customer_display':
        return Boolean(dataCustomerDisplay?.is_completed);
      case 'npd_presentation':
        return Boolean(dataNpsPresentation?.is_completed);
      case 'invoice_collection':
        return Boolean(dataInvoiceCollection?.is_completed);
      case 'visibility_update':
        return Boolean(
          dataVisibilityUpdate?.is_completed ||
            dataVisibilityUpdate?.products?.length > 0,
        );
      case 'competitor_update':
        return Boolean(dataCompetitorUpdate?.is_completed);
      case 'orders':
        return Boolean(dataOrder?.is_completed || !detailCustomer?.is_active);
      case 'upload_store_photo':
        return Boolean(dataSharePhoto?.is_completed);
      case 'gwp_tracker':
        return Boolean(dataGwpTracker?.is_completed);
      case 'sell_out_report':
        return Boolean(dataSellOutReport?.is_completed);
      default:
        return false;
    }
  };

  const requiredTargets = (() => {
    if (activityType == 'visiting_existing_customer') {
      if (userData?.role?.code == 'beauty_advisor') {
        return ['customer_display', 'visibility_update', 'gwp_tracker'];
      }

      if (userData?.role?.code == 'merchandiser') {
        return [
          'customer_display',
          'npd_presentation',
          'visibility_update',
          'competitor_update',
        ];
      }
      const targets = [
        'customer_display',
        'npd_presentation',
        'invoice_collection',
        'visibility_update',
        'competitor_update',
      ];
      if (detailCustomer?.is_active) {
        targets.push('orders');
      }
      return targets;
    }
    if (activityType == 'invoice_collection') {
      return ['invoice_collection'];
    }
    if (activityType == 'engage_potential_customers') {
      return ['npd_presentation', 'upload_store_photo'];
    }
    if (activityType == 'event_activity') {
      const visitReportTarget =
        userData?.role?.code === 'promotor'
          ? 'npd_presentation'
          : 'sell_out_report';
      return [
        'customer_display',
        'competitor_update',
        'visibility_update',
        'gwp_tracker',
        visitReportTarget,
      ];
    }
    return [];
  })();

  const isTargetCompleted = (targetType) =>
    getLocalCompleted(targetType) || getBackendCompleted(targetType);

  const isTargetSubmittedSuccess = (targetType) => {
    const localCompleted = getLocalCompleted(targetType);
    const status = localSubmitStatus?.[targetType]?.status;
    const baseSuccess = localCompleted
      ? status === 'success'
      : getBackendCompleted(targetType);
    if (targetType === 'customer_display' && baseSuccess) {
      return isCustomerDisplayReadyForCheckout();
    }
    return baseSuccess;
  };

  const localCompletedTargets = defaultTabs
    .map((tab) => tab.value)
    .filter((targetType) => getLocalCompleted(targetType));

  const submitScopeTargets = Array.from(
    new Set([...requiredTargets, ...localCompletedTargets]),
  );

  const canSubmitTodos =
    isCheckedIn &&
    requiredTargets.length > 0 &&
    requiredTargets.every((target) => isTargetCompleted(target)) &&
    !hasNoTodoList?.length;

  const canCheckout =
    isCheckedIn &&
    requiredTargets.length > 0 &&
    submitScopeTargets.every((target) => isTargetSubmittedSuccess(target)) &&
    !hasNoTodoList?.length;

  const getTodoLabel = (value) => {
    const tab = defaultTabs.find((item) => item.value == value);
    return tab?.label || value;
  };

  const saveDraft = useCallback(
    async ({ targetType, taskId, payload }) => {
      if (!activityId || !targetType) {
        return;
      }
      await updateOfflineState((prev) => {
        const existingTaskId = prev.items?.[targetType]?.taskId;
        if (!taskId && !existingTaskId) {
          return prev;
        }
        const items = {
          ...prev.items,
          [targetType]: {
            ...(prev.items?.[targetType] || {}),
            taskId: taskId || existingTaskId,
            payload,
            completed: prev.items?.[targetType]?.completed || false,
            updatedAt: new Date().toISOString(),
          },
        };
        return { ...prev, items };
      });
    },
    [activityId, updateOfflineState],
  );

  const completeTodoLocal = useCallback(
    async ({ targetType, taskId, payload }) => {
      if (!activityId || !targetType) {
        return;
      }
      await updateOfflineState((prev) => {
        const existingTaskId = prev.items?.[targetType]?.taskId;
        if (!taskId && !existingTaskId) {
          return prev;
        }
        const items = {
          ...prev.items,
          [targetType]: {
            ...(prev.items?.[targetType] || {}),
            taskId: taskId || existingTaskId,
            payload,
            completed: true,
            updatedAt: new Date().toISOString(),
          },
        };
        const submitStatus = {
          ...prev.submitStatus,
          [targetType]: {
            status: 'idle',
            errorMessage: '',
          },
        };
        return { ...prev, items, submitStatus };
      });
    },
    [activityId, updateOfflineState],
  );

  const setSubmitStatus = useCallback(
    async (targetType, status, errorMessage = '') => {
      await updateOfflineState((prev) => {
        const submitStatus = {
          ...prev.submitStatus,
          [targetType]: { status, errorMessage },
        };
        return { ...prev, submitStatus };
      });
    },
    [updateOfflineState],
  );

  const submitVisibilityUpdate = async (taskId, payload) => {
    try {
      const storageKey = `TODO_VISIBILITY_DELETE_IDS_${activityId}_${taskId}`;
      const idsString = await AsyncStorage.getItem(storageKey);
      if (idsString) {
        const ids = JSON.parse(idsString);
        if (Array.isArray(ids) && ids.length) {
          for (const id of ids) {
            try {
              await MsB2b.deleteVisibilityUpdateProduct(activityId, taskId, id);
            } catch (error) {
              console.log('failed delete product visibility update', error);
              console.log(
                'error',
                error?.response?.data?.message || error?.message,
              );
            }
          }
          await AsyncStorage.removeItem(storageKey);
        }
      }
    } catch (error) {
      console.log('failed process delete product visibility update', error);
    }

    if (!payload?.products?.length) {
      throw new Error(
        'Product visibility update must contain at least one product.',
      );
    }
    const { products_raw, ...payloadSafe } = payload || {};
    const batchSize = 50;
    let start = 0;
    while (start < payload.products.length) {
      const end = Math.min(start + batchSize, payload.products.length);
      const payload_products_update = payload.products.slice(start, end);
      start += batchSize;
      await MsB2b.activityTodosTypeUpdate(
        activityId,
        taskId,
        'visibility_update',
        {
          ...payloadSafe,
          products: payload_products_update,
        },
      );
    }

    try {
      const todos = await MsB2b.getActivitiesTodos(activityId);
      if (todos?.data?.data) {
        const todoItems = todos.data.data;
        const visibility_update_task = todoItems.find(
          (item) => item.target_type === 'visibility_update',
        );
        const visibility_update_task_id = visibility_update_task?._id;
        const products = [];
        if (visibility_update_task_id) {
          let skip = 0;
          const limit = 10;
          let hasMore = true;

          while (hasMore) {
            const visibility_update_task_detail =
              await MsB2b.getActivityTodosDetail(
                activityId,
                visibility_update_task_id,
                {
                  params: {
                    skip,
                    limit,
                    sort: 'name',
                  },
                },
              );

            const other_products = await MsB2b.getOtherProducts(activityId, {
              params: {
                skip,
                limit,
                sort: 'product.name',
              },
            });

            const visibilityData =
              visibility_update_task_detail?.data?.data || [];
            const otherProductsData = other_products?.data?.data || [];

            if (otherProductsData.length) {
              products.push(...otherProductsData);
            }
            if (visibilityData.length) {
              products.push(...visibilityData);
            }

            if (otherProductsData.length || visibilityData.length) {
              skip += limit;
            } else {
              hasMore = false;
            }
          }
        }

        const newState = await (async () => {
          const prev = offlineRef.current;
          const currentPayload = prev?.items?.visibility_update?.payload;

          if (!products?.length) {
            return prev;
          }

          const rebuiltProducts = products.map((p) => {
            const isBeginning = !!p.is_beginning;

            return {
              product_name: p.name,
              product_id: p.product_id,
              combination_id: p.combination?.id,
              quantity: p.quantity,
              pricing: p.pricing,
              is_beginning: isBeginning,
              expires_in_3_months: p.expires_in_3_months,
              expires_in_12_months: p.expires_in_12_months,

              ...(!isBeginning && {
                sell_in: p.sell_in,
                sell_out: p.sell_out,
                return: p.return,
                // B2B-5929: keep typed value sell out (promotor online)
                value_sell_out: p.value_sell_out,
              }),

              result_quantity: p.result_quantity,
              edited_reason_result_quantity: p.edited_reason_result_quantity,
              is_ending_edited: p.is_ending_edited,
              is_other: p.is_other ?? false,
              promo_status: resolvePromoStatus(p),
              promo_list: p.promo_list ?? [],
              is_wobbler: p.is_wobbler ?? null,
              notes: p.notes ?? '',

              _id: p._id,
              vu_id: p._id,
            };
          });

          const rebuiltProductsRaw = products.map((p) => {
            const combinationId = p.combination?.id;
            const isBeginning = !!p.is_beginning;

            return {
              id: p.product_id,
              name: p.name,
              image: p.image,
              brand: {
                id: p.brand?.id,
                name: p.brand?.name,
              },
              quantity: p.quantity,

              combination: {
                id: combinationId,
                reference: p.combination?.reference,
                variant: p.combination?.variant,
                is_other: p.is_other ?? false,
              },

              is_selected: true,
              is_beginning: isBeginning,

              ...(!isBeginning && {
                stock: p.quantity,
                sell_in: p.sell_in,
                sell_out: p.sell_out,
                return: p.return,
                value_sell_out: p.value_sell_out,
              }),

              result_quantity: p.result_quantity,
              endingStock: p.result_quantity,

              pricing: p.pricing,
              expires_in_3_months: p.expires_in_3_months,
              expires_in_12_months: p.expires_in_12_months,
              promo_status: resolvePromoStatus(p),
              promo_list: p.promo_list ?? [],
              is_wobbler: p.is_wobbler ?? null,
              notes: p.notes ?? '',

              product_id: p.product_id,
              is_initiate: false,
              isFromStorage: true,
              isFromDB: true,
              is_saved: true,
              is_other: p.is_other ?? false,

              vu_id: p._id,
              _id: p._id,
            };
          });

          return {
            ...prev,
            items: {
              ...prev.items,
              visibility_update: {
                ...prev.items.visibility_update,
                payload: {
                  ...currentPayload,
                  products: rebuiltProducts,
                  products_raw: rebuiltProductsRaw,
                },
              },
            },
          };
        })();

        await updateOfflineState(() => newState);
      }
    } catch (error) {
      console.log('Failed to sync visibility IDs', error);
    }
  };

  const resolveLocalFile = (localFile) => {
    if (!localFile) {
      return localFile;
    }
    if (localFile.filename) {
      return localFile;
    }
    const uri = localFile.uri || '';
    const uriFilename = uri.split('/').pop() || uri.split('%2F').pop() || '';
    const hasExt = uriFilename.includes('.');
    if (hasExt) {
      return { ...localFile, filename: uriFilename };
    }
    const mimeType = localFile.mimeType || localFile.type || '';
    const ext = mimeType.includes('png')
      ? 'png'
      : mimeType.includes('gif')
      ? 'gif'
      : 'jpg';
    return { ...localFile, filename: `${Date.now()}.${ext}` };
  };

  // B2B-5776: uploaded one at a time on purpose. Minting every pre-signed url
  // up front let the later ones expire (60s) while queued behind the earlier
  // transfers, and the rejected upload was then stored as if it succeeded.
  const uploadLocalImages = async (images = []) => {
    const uploaded = [];
    for (const img of images) {
      if (!img?._localFile) {
        uploaded.push(img);
        continue;
      }
      const cdnUrl = await uploadS3({
        file: resolveLocalFile(img._localFile),
        isImage: true,
      });
      if (!cdnUrl) {
        throw new Error('upload_failed');
      }
      const { _localFile, ...rest } = img;
      uploaded.push({ ...rest, url: cdnUrl, uri: cdnUrl });
    }
    return uploaded;
  };

  const uploadPayloadImages = async (payload) => {
    if (!payload?.more_info?.attachments?.length) {
      return payload;
    }
    const attachments = await Promise.all(
      payload.more_info.attachments.map(async (attachment) => {
        if (!attachment?.image?.length) {
          return attachment;
        }
        const image = await uploadLocalImages(attachment.image);
        return { ...attachment, image };
      }),
    );
    return { ...payload, more_info: { ...payload.more_info, attachments } };
  };

  const uploadGwpImages = async (payload) => {
    if (!payload?.more_info?.campaign?.length) {
      return payload;
    }
    const campaign = await Promise.all(
      payload.more_info.campaign.map(async (item) => {
        if (!item?.images?.length) {
          return item;
        }
        const uploaded = await uploadLocalImages(item.images);
        const images = uploaded.map((img) =>
          typeof img === 'string' ? img : img?.url || img?.uri || '',
        );
        return { ...item, images };
      }),
    );
    return { ...payload, more_info: { ...payload.more_info, campaign } };
  };

  const submitTodoItem = async (targetType) => {
    const localItem = offlineRef.current?.items?.[targetType];
    let payload = localItem?.payload;
    const taskId = localItem?.taskId || _getTaskIdForItem(targetType);

    if (!payload || !taskId) {
      await setSubmitStatus(targetType, 'failed', 'Data is empty');
      return false;
    }

    await setSubmitStatus(targetType, 'submitting');
    try {
      if (targetType === 'gwp_tracker') {
        payload = await uploadGwpImages(payload);
      } else {
        payload = await uploadPayloadImages(payload);
      }

      if (targetType === 'visibility_update') {
        await submitVisibilityUpdate(taskId, payload);
      } else {
        const response = await MsB2b.activityTodosUpdate(
          activityId,
          taskId,
          payload,
        );
        if (!response?.data?.data) {
          throw new Error('submit_failed');
        }
      }
      await setSubmitStatus(targetType, 'success');
      return true;
    } catch (error) {
      // B2B-5776: an upload rejected by S3 has no api response to read a
      // message from, so name it explicitly instead of falling through to the
      // generic one
      const uploadFailed = error?.message === 'upload_failed';
      const message =
        error?.response?.data?.message ||
        (uploadFailed
          ? 'Photo failed to upload. Check your connection and tap Retry.'
          : 'A system error occurred');
      await setSubmitStatus(targetType, 'failed', message);
      return false;
    }
  };

  const submitAllTodos = async () => {
    if (!submitScopeTargets.length) {
      return;
    }
    setIsSubmittingTodos(true);
    for (let i = 0; i < submitScopeTargets.length; i++) {
      const targetType = submitScopeTargets[i];
      if (!getLocalCompleted(targetType)) {
        continue;
      }
      if (
        offlineRef.current?.submitStatus?.[targetType]?.status === 'success'
      ) {
        continue;
      }
      await submitTodoItem(targetType);
    }
    setIsSubmittingTodos(false);
  };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (
        latLong &&
        Object.keys(latLong).length &&
        customerLatLong &&
        Object.keys(customerLatLong).length
      ) {
        const checkNearby = calculateLocationDistance(
          latLong.latitude,
          latLong.longitude,
          outletDetail ? outletLatLong.latitude : customerLatLong.latitude,
          outletDetail ? outletLatLong.longitude : customerLatLong.longitude,
        );
        setDistanceInM(checkNearby * 1000);
        let is_km = true;
        let our_distance = Math.round(checkNearby);
        if (checkNearby > 1.5) {
          setShowUpdateLocation(true);
        }
        if (our_distance < 1) {
          is_km = false;
          our_distance = our_distance * 1000;
        }
        our_distance = `${our_distance} ${is_km ? `km` : `m`}`;
        setDistance(our_distance);
      }
    }
    return () => {
      mounted = false;
    };
  }, [latLong, customerLatLong]);

  const onProcessTask = async (type) => {
    if (type == 'checkout') {
      const checkoutValidation = submitScopeTargets
        .filter((targetType) => !isTargetSubmittedSuccess(targetType))
        .map((targetType) => getTodoLabel(targetType));
      if (checkoutValidation?.length) {
        dispatch(
          showAlert({
            show: true,
            isModal: true,
            title: 'Error',
            description: `${checkoutValidation.join(', ')} is not completed.`,
            isConfirm: false,
            testID: 'todo-user-checkout-validation',
          }),
        );
        return;
      }
    }
    dispatch(showPopup({ name: 'isLoading', value: true }));
    try {
      logEvent({
        eventName: `${type}_activity`,
        data: {
          activity_id: detailData?._id,
          lat_long: latLong,
          type,
          app_version: VERSION,
        },
        dataKey: 'detail',
      });
      if (type === 'checkout' && activityType === 'event_activity') {
        logEvent({
          eventName: SALES_ACTIVITY_PROMOTOR_CHECKOUT,
          data: { activity_id: detailData?._id },
          dataKey: 'detail',
        });
      }
      let checkInOut = null;
      if (type == 'checkin') {
        checkInOut = await MsB2b.activityCheckin(detailData._id, {
          is_check_in: true,
          lat_long: {
            latitude: latLong.latitude,
            longitude: latLong.longitude,
          },
          app_version: VERSION,
          distance: distanceInM,
          check_in_validation: !showUpdateLocation,
          check_in_notes: checkInNotes,
        });
      } else {
        checkInOut = await MsB2b.activityCheckout(detailData._id);
      }
      if (checkInOut?.data?.data) {
        if (type == 'checkin') {
          setIsCheckedIn(true);
        } else {
          await clearActivityTodoStorage(detailData?._id);
          await clearVisibilityCacheByActivity(detailData?._id);
          const empty = { items: {}, submitStatus: {} };
          offlineRef.current = empty;
          setOfflineTodo(empty);
          setIsCheckedOut(true);
        }
        dispatch(showPopup({ name: 'isLoading', value: false }));
        onSubmit();
      } else {
        dispatch(showPopup({ name: 'isLoading', value: false }));
        dispatch(
          showAlert({
            show: true,
            isModal: true,
            title: 'Error',
            description: 'A system error occurred.',
            isConfirm: false,
            testID: 'todo-user-checkout-error',
          }),
        );
      }
    } catch (error) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      dispatch(
        showAlert({
          show: true,
          isModal: true,
          title: 'Error',
          description:
            error?.response?.data?.message || 'A system error occurred',
          isConfirm: false,
          testID: 'todo-user-checkout-error',
        }),
      );
    }
  };

  const onSkipActivity = async (type = 'competitor_update') => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    try {
      const payload = {
        ...(type == 'competitor_update'
          ? {
              more_info: {
                attachments: [
                  {
                    type: 'competitor',
                    name: 'competitor_update',
                    image: [],
                  },
                ],
              },
            }
          : type == 'sell_out_report'
          ? {
              more_info: {
                report: [],
              },
            }
          : type == 'gwp_tracker'
          ? {
              more_info: {
                campaign: [],
              },
            }
          : type == 'invoice_collection'
          ? {
              more_info: {
                notes: [],
              },
            }
          : {}),
      };
      let todoId = dataCompetitorUpdate?._id;
      if (type == 'orders') {
        todoId = dataOrder?._id;
      } else if (type == 'sell_out_report') {
        todoId = dataSellOutReport?._id;
      } else if (type == 'gwp_tracker') {
        todoId = dataGwpTracker?._id;
      } else if (type == 'invoice_collection') {
        todoId = dataInvoiceCollection?._id;
      }
      if (!todoId) {
        throw new Error('todo_not_found');
      }
      await completeTodoLocal({
        targetType: type,
        taskId: todoId,
        payload,
      });
      dispatch(showPopup({ name: 'isLoading', value: false }));
      setActiveTab('');
    } catch (error) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      let error_message = 'A system error occurred';
      if (error?.response?.data?.message) {
        error_message = error.response.data.message;
      }
      if (!dataCompetitorUpdate?._id) {
        error_message = 'This activity have no todo list activity.';
      }
      dispatch(
        showAlert({
          show: true,
          isModal: true,
          title: 'Error',
          description: error_message,
          isConfirm: false,
          testID: 'todo-user-checkin-validation',
        }),
      );
    }
  };

  const CATEGORY_ACTIVITY_OPTIONS = [
    { label: 'Instore', value: 'INSTORE' },
    { label: 'Outstore', value: 'OUTSTORE' },
    { label: 'Online', value: 'ONLINE' },
  ];

  const EVENT_ACTIVITY_MAP = {
    INSTORE: [
      { label: 'Open Booth', value: 'OPEN BOOTH' },
      { label: 'Event Desk', value: 'EVENT DESK' },
      { label: 'Makeup Demo', value: 'MAKEUP DEMO' },
      { label: 'Beauty Workshop', value: 'BEAUTY WORKSHOP' },
      { label: 'Promo Troly/Keranjang', value: 'PROMO TROLY/KERANJANG' },
      { label: 'Podium', value: 'PODIUM' },
      { label: 'Skin Care Demo', value: 'SKIN CARE DEMO' },
      { label: 'Others', value: 'OTHERS' },
    ],
    OUTSTORE: [
      { label: 'Open Booth', value: 'OPEN BOOTH' },
      { label: 'Event Desk', value: 'EVENT DESK' },
      { label: 'Makeup Demo', value: 'MAKEUP DEMO' },
      { label: 'Beauty Workshop', value: 'BEAUTY WORKSHOP' },
      { label: 'Promo Troly/Keranjang', value: 'PROMO TROLY/KERANJANG' },
      { label: 'Podium', value: 'PODIUM' },
      { label: 'Skin Care Demo', value: 'SKIN CARE DEMO' },
      { label: 'Grebek Pasar', value: 'GREBEK PASAR' },
      { label: 'Pitching', value: 'PITCHING' },
      { label: 'Others', value: 'OTHERS' },
    ],
    ONLINE: [
      { label: 'IG Live', value: 'IG LIVE' },
      { label: 'Shopee Live', value: 'SHOPEE LIVE' },
      { label: 'Tokopedia Live', value: 'TOKOPEDIA LIVE' },
      { label: 'TikTok Live', value: 'TIKTOK LIVE' },
      { label: 'Lazada Live', value: 'LAZADA LIVE' },
      { label: 'Others', value: 'OTHERS' },
    ],
  };

  const isCategoryActivitySaved = Boolean(
    detailData?.category_activity && detailData?.event_activity_type,
  );

  const saveCategoryActivity = async () => {
    if (!categoryActivity || !eventActivityType) {
      dispatch(
        showAlert({
          show: true,
          isModal: true,
          title: 'Error',
          description: 'Category Activity and Event Activity are required.',
          isConfirm: false,
          testID: 'todo-user-save-category-validation',
        }),
      );
      return;
    }
    if (eventActivityType === 'OTHERS' && !eventActivityOther) {
      dispatch(
        showAlert({
          show: true,
          isModal: true,
          title: 'Error',
          description: 'Please specify the event activity.',
          isConfirm: false,
          testID: 'todo-user-save-category-validation',
        }),
      );
      return;
    }
    setIsSavingCategoryActivity(true);
    dispatch(showPopup({ name: 'isLoading', value: true }));
    try {
      logEvent({
        eventName: SALES_ACTIVITY_CATEGORY_SELECTED,
        data: { category: categoryActivity },
        dataKey: 'detail',
      });
      logEvent({
        eventName: SALES_ACTIVITY_EVENT_TYPE_SELECTED,
        data: { event_type: eventActivityType },
        dataKey: 'detail',
      });
      const payload = {
        category_activity: categoryActivity,
        event_activity_type:
          eventActivityType === 'OTHERS'
            ? eventActivityOther
            : eventActivityType,
        ...(eventActivityType === 'OTHERS'
          ? { event_activity_other: eventActivityOther }
          : {}),
      };
      await MsB2b.updateSalesActivity(detailData._id, payload);
      dispatch(showPopup({ name: 'isLoading', value: false }));
      setIsCategoryFormOpen(false);
      onSubmit();
    } catch (error) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      dispatch(
        showAlert({
          show: true,
          isModal: true,
          title: 'Error',
          description:
            error?.response?.data?.message || 'A system error occurred',
          isConfirm: false,
          testID: 'todo-user-save-category-error',
        }),
      );
    } finally {
      setIsSavingCategoryActivity(false);
    }
  };

  const renderLoading = () => (
    <View style={styles.paddingTwenty}>
      <Loader />
    </View>
  );

  const renderNotPermissions = () => (
    <View style={styles.paddingTwenty}>
      <SociollaText style={{ color: Colors.grey1 }}>
        You dont have location permission
      </SociollaText>
    </View>
  );

  const renderTodoListWarning = () => {
    const shouldNotRender = !isCheckedIn || !hasNoTodoList?.length;

    return (
      !shouldNotRender && (
        <View
          style={{
            width: '100%',
            padding: 10,
            borderTopWidth: 1,
            borderTopColor: Colors.grey0,
          }}>
          <SociollaText style={{ fontSize: 11 }}>
            {hasNoTodoList.map((item) => item.label).join(', ')} have no todo
            list. It makes you unable to submit the todo list. Please contact
            your administrator.
          </SociollaText>
        </View>
      )
    );
  };

  const renderCheckInButton = () => (
    <Button
      testID="todo-user-check-in-btn"
      rounded={true}
      buttonStyle={{ width: checkInOutSize }}
      disabledStyle={{ width: checkInOutSize }}
      disabled={isLoadingGlobal}
      title={
        <SociollaText
          type="medium"
          style={{ fontSize: 14, color: Colors.white }}>
          Check In
        </SociollaText>
      }
      onPress={() => {
        if (showUpdateLocation) {
          setCheckInNotes('');
          setModalCheckInValidation(true);
        } else {
          onProcessTask('checkin');
        }
      }}
    />
  );

  const renderUpdateLocationText = () =>
    showUpdateLocation && (
      <View
        style={[
          styles.textUpdate,
          styles.textUpdatePadding,
          { maxWidth: fullWidth - checkInOutSize - 40 },
        ]}>
        <SociollaText style={styles.textUpdate}>
          Your position is {distance} from the store
        </SociollaText>
      </View>
    );

  const renderCheckInSection = () => (
    <View style={styles.checkinWrapper}>
      {renderCheckInButton()}
      {renderUpdateLocationText()}
    </View>
  );

  const renderCheckInContent = () => (
    <View style={styles.todoChild}>
      {isLoadingLocation ? (
        <SociollaText style={styles.textUpdateLoading}>
          Updating location...
        </SociollaText>
      ) : (
        renderCheckInSection()
      )}
    </View>
  );

  const renderCheckInLogic = () => (
    <React.Fragment>
      <TodoTitle title="CHECK IN" isActive={isCheckedIn} />
      {!isCheckedIn && renderCheckInContent()}
    </React.Fragment>
  );

  const renderCheckOutButton = () => (
    <Button
      testID="todo-user-check-out-btn"
      rounded={true}
      buttonStyle={{ width: checkInOutSize }}
      disabledStyle={{ width: checkInOutSize }}
      disabled={
        !isCheckedIn || !canCheckout || isLoadingGlobal || isSubmittingTodos
      }
      title={
        <SociollaText
          type="medium"
          style={{ fontSize: 14, color: Colors.white }}>
          Check Out
        </SociollaText>
      }
      onPress={() => onProcessTask('checkout')}
    />
  );

  const renderCheckOutSection = () =>
    isCheckedIn && canCheckout ? (
      <View style={[styles.todoChild, styles.checkout, { paddingBottom: 80 }]}>
        {renderCheckOutButton()}
      </View>
    ) : null;

  const getSubmitDisplayStatus = (targetType) => {
    if (hasNoTodoList.find((item) => item.value == targetType)) {
      return 'missing';
    }
    const status = localSubmitStatus?.[targetType]?.status;
    const isCustomerDisplayIncomplete =
      targetType === 'customer_display' && !isCustomerDisplayReadyForCheckout();
    if (status && status !== 'idle') {
      return status === 'success' && isCustomerDisplayIncomplete
        ? 'incomplete'
        : status;
    }
    if (!submitScopeTargets.includes(targetType)) {
      return 'skipped';
    }
    if (!isTargetCompleted(targetType) || isCustomerDisplayIncomplete) {
      return 'incomplete';
    }
    if (!getLocalCompleted(targetType) && getBackendCompleted(targetType)) {
      return 'success';
    }
    return 'idle';
  };

  const getSubmitStatusLabel = (status) => {
    switch (status) {
      case 'submitting':
        return 'Submitting';
      case 'success':
        return 'Success';
      case 'failed':
        return 'Failed';
      case 'missing':
        return 'Not available';
      case 'incomplete':
        return 'Incomplete';
      case 'skipped':
        return 'Skipped';
      default:
        return 'Ready to submit';
    }
  };

  const getSubmitStatusColor = (status) => {
    switch (status) {
      case 'success':
        return Colors.green1;
      case 'failed':
        return Colors.red0;
      case 'submitting':
        return Colors.blue0;
      case 'missing':
      case 'incomplete':
        return Colors.grey1;
      default:
        return Colors.grey2;
    }
  };

  const renderSubmitSection = () =>
    isCheckedIn && canSubmitTodos && !canCheckout ? (
      <View style={[styles.todoChild, { paddingBottom: 10 }]}>
        <Button
          testID="todo-user-submit-btn"
          rounded
          buttonStyle={{ width: checkInOutSize }}
          disabledStyle={{ width: checkInOutSize }}
          disabled={isSubmittingTodos || isLoadingGlobal}
          title={
            <SociollaText
              type="medium"
              style={{ fontSize: 14, color: Colors.white }}>
              Submit
            </SociollaText>
          }
          onPress={() => {
            if (
              submitScopeTargets.includes('customer_display') &&
              !isCustomerDisplayReadyForCheckout()
            ) {
              dispatch(
                showAlert({
                  show: true,
                  isModal: true,
                  title: 'Error',
                  description: `To do list ${getTodoLabel(
                    'customer_display',
                  )} is not completed.`,
                  isConfirm: false,
                  testID: 'todo-user-submit-validation',
                }),
              );
              return;
            }
            setShowSubmitModal(true);
            submitAllTodos();
          }}
        />
      </View>
    ) : null;

  const renderSubmitModal = () => (
    <ModalHalf
      testID="todo-user-submit-modal"
      title={'Status Todo List'}
      visible={showSubmitModal}
      closeOutside={false}
      onClose={() => setShowSubmitModal(false)}>
      <View style={styles.submitModalContainer}>
        {visibleTabs.map((item) => {
          const status = getSubmitDisplayStatus(item.value);
          const errorMessage =
            localSubmitStatus?.[item.value]?.errorMessage || '';
          const isSubmitting = status === 'submitting';
          const isFailed = status === 'failed';
          return (
            <View key={item.value} style={styles.submitModalRow}>
              <View style={styles.submitModalRowTop}>
                <SociollaText style={styles.submitModalTodoLabel}>
                  {getTodoLabel(item.value)}
                </SociollaText>
                <View style={styles.submitStatusWrapper}>
                  {isSubmitting ? (
                    <ActivityIndicator
                      size="small"
                      color={Colors.blue0}
                      style={styles.submitStatusSpinner}
                    />
                  ) : null}
                  <SociollaText
                    type="medium"
                    style={[
                      styles.submitStatusText,
                      { color: getSubmitStatusColor(status) },
                    ]}>
                    {getSubmitStatusLabel(status)}
                  </SociollaText>
                </View>
              </View>
              {isFailed && errorMessage ? (
                <View style={styles.submitErrorBox}>
                  <SociollaText style={styles.submitErrorText}>
                    {errorMessage}
                  </SociollaText>
                </View>
              ) : null}
              {isFailed ? (
                <View style={styles.submitRetryWrapper}>
                  <Button
                    testID="todo-user-retry-btn"
                    rounded
                    type="default"
                    buttonStyle={styles.submitRetryButton}
                    title={
                      <SociollaText
                        type="medium"
                        style={{ fontSize: 12, color: Colors.blue0 }}>
                        Retry
                      </SociollaText>
                    }
                    onPress={() => submitTodoItem(item.value)}
                  />
                </View>
              ) : null}
            </View>
          );
        })}
      </View>
    </ModalHalf>
  );

  const renderCheckOutLogic = () => {
    if (activityType !== 'engage_potential_customers' && canCheckout) {
      return (
        <React.Fragment>
          <TodoTitle title="CHECK OUT" isActive={isCheckedOut} />
          {renderCheckOutSection()}
        </React.Fragment>
      );
    }
  };

  const _getDataForItem = (itemValue) => {
    switch (itemValue) {
      case 'customer_display':
        return dataCustomerDisplay;
      case 'npd_presentation':
        return dataNpsPresentation;
      case 'invoice_collection':
        return dataInvoiceCollection;
      case 'visibility_update':
        return dataVisibilityUpdate;
      case 'competitor_update':
        return dataCompetitorUpdate;
      case 'orders':
        return dataOrder;
      case 'gwp_tracker':
        return dataGwpTracker;
      case 'sell_out_report':
        return dataSellOutReport;
      default:
        return dataSharePhoto;
    }
  };

  const _getTaskIdForItem = (itemValue) => {
    switch (itemValue) {
      case 'customer_display':
        return dataCustomerDisplay?._id;
      case 'npd_presentation':
        return dataNpsPresentation?._id;
      case 'invoice_collection':
        return dataInvoiceCollection?._id;
      case 'visibility_update':
        return dataVisibilityUpdate?._id;
      case 'competitor_update':
        return dataCompetitorUpdate?._id;
      case 'orders':
        return dataOrder?._id;
      case 'gwp_tracker':
        return dataGwpTracker?._id;
      case 'sell_out_report':
        return dataSellOutReport?._id;
      default:
        return dataSharePhoto?._id;
    }
  };

  const _getTabExpandProps = (item) => ({
    title: item.label,
    value: item.value,
    data: _getDataForItem(item.value),
    customerActived: Boolean(detailCustomer?.is_active),
    hasNoTodoList: hasNoTodoList,
    hasNoInvoice: hasNoInvoice,
    hasNoVisibility: !isTargetCompleted('visibility_update'),
    setActiveTab: (val) => setActiveTab(val),
    isCompletedLocal: getLocalCompleted(item.value),
    localPayload: getLocalPayload(item.value),
    isLocked: false,
  });

  const renderTabModalContent = (item) => {
    switch (item.value) {
      case 'customer_display':
        return (
          <TodoCustomerDisplay
            containerHeight={containerHeight}
            detailData={detailData}
            detailTodo={dataCustomerDisplay}
            localPayload={getLocalPayload('customer_display')}
            onSubmit={completeTodoLocal}
            onSaveDraft={saveDraft}
            resetTab={() => setActiveTab('')}
          />
        );
      case 'competitor_update':
        return (
          <TodoCompetitorUpdate
            containerHeight={containerHeight}
            detailData={detailData}
            detailTodo={dataCompetitorUpdate}
            localPayload={getLocalPayload('competitor_update')}
            onSubmit={completeTodoLocal}
            onSaveDraft={saveDraft}
            resetTab={() => setActiveTab('')}
          />
        );
      case 'visibility_update':
        return (
          <TodoVisibilityUpdate
            containerHeight={containerHeight}
            detailData={detailData}
            detailTodo={dataVisibilityUpdate}
            detailCustomer={detailCustomer}
            localPayload={getLocalPayload('visibility_update')}
            onSubmit={completeTodoLocal}
            onSaveDraft={saveDraft}
            resetTab={() => setActiveTab('')}
            customerAddress={customerAddress}
            navigation={navigation}
          />
        );
      case 'invoice_collection':
        return (
          <TodoInvoice
            containerHeight={containerHeight}
            detailData={detailData}
            detailTodo={dataInvoiceCollection}
            detailCustomer={detailCustomer}
            localPayload={getLocalPayload('invoice_collection')}
            onSubmit={completeTodoLocal}
            onSaveDraft={saveDraft}
            resetTab={() => setActiveTab('')}
          />
        );
      case 'npd_presentation':
        return (
          <TodoNotes
            navigation={navigation}
            containerHeight={containerHeight}
            detailData={detailData}
            detailTodo={dataNpsPresentation}
            localPayload={getLocalPayload('npd_presentation')}
            onSubmit={completeTodoLocal}
            onSaveDraft={saveDraft}
            resetTab={() => setActiveTab('')}
            openCatalog={() => {
              setActiveTab('');
              setShowCatalog(true);
            }}
          />
        );
      case 'upload_store_photo':
        return (
          <TodoUploadSharePhoto
            containerHeight={containerHeight}
            detailData={detailData}
            detailTodo={dataSharePhoto}
            localPayload={getLocalPayload('upload_store_photo')}
            onSubmit={completeTodoLocal}
            onSaveDraft={saveDraft}
            resetTab={() => setActiveTab('')}
          />
        );
      case 'orders':
        return (
          <TodoOrder
            navigation={navigation}
            containerHeight={containerHeight}
            detailData={detailData}
            detailTodo={dataOrder}
            detailCustomer={detailCustomer}
            localPayload={getLocalPayload('orders')}
            onSubmit={completeTodoLocal}
            onSaveDraft={saveDraft}
            resetTab={() => setActiveTab('')}
            openOrdersForm={() => {
              setShowOrderForm(true);
            }}
            openOrdersDetail={(order) => {
              setActiveTab('');
              setShowOrderDetail(true);
              setOrderDetail(order);
            }}
          />
        );
      case 'gwp_tracker':
        return (
          <TodoGwpTracker
            containerHeight={containerHeight}
            detailData={detailData}
            detailTodo={dataGwpTracker}
            localPayload={getLocalPayload('gwp_tracker')}
            onSubmit={completeTodoLocal}
            onSaveDraft={saveDraft}
            resetTab={() => setActiveTab('')}
          />
        );
      case 'sell_out_report':
        return (
          <TodoSellOutReport
            containerHeight={containerHeight}
            detailData={detailData}
            detailTodo={dataSellOutReport}
            localPayload={getLocalPayload('sell_out_report')}
            onSubmit={completeTodoLocal}
            onSaveDraft={saveDraft}
            resetTab={() => setActiveTab('')}
          />
        );
      default:
        return null;
    }
  };

  const getRightAction = (item) => {
    if (
      [
        'competitor_update',
        'orders',
        'gwp_tracker',
        'sell_out_report',
      ].includes(item.value)
    ) {
      return {
        label: 'Skip',
        onCallback: () => onSkipActivity(item.value),
      };
    }
    return null;
  };

  const renderTabModal = (item) => {
    if (activeTab !== item.value) {
      return null;
    }

    return (
      <ModalFull
        testID={`todo-user-tab-modal-${item.value}`}
        title={item.label}
        show={activeTab === item.value}
        back={isWeb ? false : true}
        width={650}
        rightAction={getRightAction(item)}
        onClose={() => setActiveTab('')}>
        {renderTabModalContent(item)}
        <Alert />
      </ModalFull>
    );
  };

  const renderTabExpand = (item, idx) => (
    <View style={{ width: '100%' }} key={idx}>
      <TabExpand {..._getTabExpandProps(item)} />
      {renderTabModal(item)}
    </View>
  );

  const renderTodoList = () => (
    <View style={styles.todoChild}>
      {visibleTabs.map((item, idx) => renderTabExpand(item, idx))}
    </View>
  );

  const renderCategoryActivitySection = () => {
    if (activityType !== 'event_activity') {
      return null;
    }
    const eventOptions = categoryActivity
      ? EVENT_ACTIVITY_MAP[categoryActivity] || []
      : [];
    const isOthers = eventActivityType === 'OTHERS';
    return (
      <React.Fragment>
        <TouchableOpacity
          activeOpacity={0.7}
          onPress={() => setIsCategoryFormOpen((prev) => !prev)}
          style={styles.categoryToggleRow}>
          <SociollaText
            type="medium"
            style={{ fontSize: 13, color: Colors.grey1 }}>
            CATEGORY ACTIVITY
          </SociollaText>
          {isCategoryActivitySaved ? (
            <Image
              style={CHECK_SIZE}
              width={CHECK_SIZE.width}
              height={CHECK_SIZE.height}
              svg={true}
              source={require('@assets/img/icons/check-circle-blue.svg')}
            />
          ) : (
            <Image
              style={[
                ARROW_SIZE,
                {
                  transform: [
                    { rotate: isCategoryFormOpen ? '180deg' : '0deg' },
                  ],
                },
              ]}
              width={ARROW_SIZE.width}
              height={ARROW_SIZE.height}
              svg={true}
              source={require('@assets/img/icons/arrow-down-grey.svg')}
            />
          )}
        </TouchableOpacity>
        {isCheckedIn && isCategoryFormOpen && (
          <View style={{ width: '100%', padding: 15 }}>
            <View style={{ marginBottom: 12 }}>
              <SelectBox
                label="Category Activity"
                options={CATEGORY_ACTIVITY_OPTIONS}
                value={
                  CATEGORY_ACTIVITY_OPTIONS.find(
                    (o) => o.value === categoryActivity,
                  ) || null
                }
                placeholder="Select Category Activity"
                trackBy="value"
                labelKey="label"
                isRequired={true}
                onChange={(val) => {
                  setCategoryActivity(val?.value || '');
                  setEventActivityType('');
                  setEventActivityOther('');
                }}
              />
            </View>
            {categoryActivity ? (
              <View style={{ marginBottom: 12 }}>
                <SelectBox
                  label="Event Activity"
                  options={eventOptions}
                  value={
                    eventOptions.find((o) => o.value === eventActivityType) ||
                    null
                  }
                  placeholder="Select Event Activity"
                  trackBy="value"
                  labelKey="label"
                  isRequired={true}
                  onChange={(val) => {
                    setEventActivityType(val?.value || '');
                    setEventActivityOther('');
                  }}
                />
              </View>
            ) : null}
            {isOthers ? (
              <View style={{ marginBottom: 12 }}>
                <Input
                  label="Specify Event Activity"
                  isRequired={true}
                  placeholder="Enter event activity"
                  value={eventActivityOther}
                  onChangeText={(val) => setEventActivityOther(val)}
                />
              </View>
            ) : null}
            <Button
              testID="todo-user-save-category-btn"
              rounded={true}
              buttonStyle={{ width: '100%' }}
              disabled={isSavingCategoryActivity}
              title={
                <SociollaText
                  type="bold"
                  style={{
                    fontSize: 14,
                    letterSpacing: 0.5,
                    color: Colors.white,
                  }}>
                  Save
                </SociollaText>
              }
              onPress={saveCategoryActivity}
            />
          </View>
        )}
      </React.Fragment>
    );
  };

  const renderToDoContent = () => (
    <React.Fragment>
      {renderTodoListWarning()}
      {renderCheckInLogic()}
      {renderCategoryActivitySection()}
      <TodoTitle title="TO DO LIST" />
      {isCheckedIn &&
        (activityType !== 'event_activity' || isCategoryActivitySaved) &&
        renderTodoList()}
      {renderSubmitSection()}
      {renderCheckOutLogic()}
      {renderSubmitModal()}
      {renderCheckInValidation()}
    </React.Fragment>
  );

  const renderContent = () => {
    const isMeetValidation = hasLocation || isCheckedIn;

    return (
      <React.Fragment>
        {isMeetValidation && renderToDoContent()}
        {!isMeetValidation && renderNotPermissions()}
      </React.Fragment>
    );
  };

  const renderCheckInValidation = () => {
    return (
      <ModalHalf
        testID="todo-user-check-in-validation-modal"
        title={'Attention'}
        visible={modalCheckInValidation}
        onClose={() => {
          setCheckInNotes('');
          setModalCheckInValidation(false);
        }}>
        <View style={{ width: '100%', padding: 16 }}>
          <SociollaText style={{ fontSize: 12, marginBottom: 15 }}>
            You are about to check in outside the store area. If this location
            is incorrect, please provide an explanation in the notes below.
          </SociollaText>

          <Input
            label="Notes (Optional)"
            value={checkInNotes}
            onChangeText={(val) => {
              setCheckInNotes(val);
            }}
          />

          <View style={{ width: '100%', marginTop: 10 }}>
            <Button
              testID="todo-user-check-in-submit-btn"
              rounded
              buttonStyle={{ width: '100%' }}
              title={
                <SociollaText
                  type="bold"
                  style={{
                    fontSize: 14,
                    letterSpacing: 0.5,
                    color: Colors.white,
                  }}>
                  Submit
                </SociollaText>
              }
              onPress={() => {
                onProcessTask('checkin');
                setModalCheckInValidation(false);
              }}
            />
          </View>
        </View>
      </ModalHalf>
    );
  };

  const shouldLoading =
    !isCheckedIn &&
    (!hasLocation || currentLocation?.loading) &&
    !(currentLocation.error && !currentLocation.loading) &&
    !(!currentLocation.loading && currentLocation.error === '');

  return (
    <View testID="todo-user-container" style={{ width: '100%' }}>
      {shouldLoading ? renderLoading() : renderContent()}
    </View>
  );
};

const styles = StyleSheet.create({
  todoChild: { width: '100%', padding: 15 },
  categoryToggleRow: {
    width: '100%',
    padding: 15,
    backgroundColor: Colors.grey19,
    borderTopColor: Colors.grey0,
    borderBottomColor: Colors.grey0,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  checkout: { marginBottom: 50 },
  checkinWrapper: { flexDirection: 'row' },
  textUpdate: {
    fontSize: 12,
    lineHeight: 16,
    color: Colors.red0,
    justifyContent: 'center',
  },
  textUpdatePadding: { paddingLeft: 10 },
  textUpdateLoading: { fontSize: 12 },
  paddingTwenty: { padding: 20 },
  submitModalContainer: {
    width: '100%',
    padding: 16,
  },
  submitModalRow: {
    width: '100%',
    paddingVertical: 10,
    borderBottomWidth: 1,
    borderBottomColor: Colors.grey0,
  },
  submitModalRowTop: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
  },
  submitModalTodoLabel: {
    flex: 1,
    fontSize: 12,
  },
  submitStatusWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  submitStatusSpinner: {
    marginRight: 6,
  },
  submitStatusText: {
    fontSize: 11,
  },
  submitErrorBox: {
    width: '100%',
    marginTop: 6,
    paddingVertical: 6,
    paddingHorizontal: 8,
    borderRadius: 6,
    backgroundColor: Colors.red4,
  },
  submitErrorText: {
    fontSize: 10,
    color: Colors.red0,
  },
  submitRetryWrapper: {
    width: 110,
    marginTop: 8,
  },
  submitRetryButton: {
    width: 110,
  },
});

export default React.memo(TodoListUser, (prev, next) => prev == next);
